import request from './axiosClient';
import { AxiosResponse } from 'axios';
const SHOP = '/shop-public';
const URL_SETTINGS = '/get-shop-settings-public';

export function getShopInfoApi(shop_id: number, appName: string): Promise<AxiosResponse<any>> {
  return request({
    url: `${SHOP}/${shop_id}`,
    method: 'get',
    noNeedToken: true,
    params: {
      appName,
    },
  });
}

// SHOP SETTINGS
export function getShopSettingsAPI(params: any) {
  return request({
    url: URL_SETTINGS,
    method: 'get',
    noNeedToken: true,
    params,
  });
}
